export const AUTH = {
  token: "access_token",
  user: "user",
};
